import { render, staticRenderFns } from "./EmergencyTool.vue?vue&type=template&id=6ec008ac&scoped=true&"
import script from "./EmergencyTool.vue?vue&type=script&lang=js&"
export * from "./EmergencyTool.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyTool.vue?vue&type=style&index=0&id=6ec008ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec008ac",
  null
  
)

export default component.exports